"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexController = void 0;
const _ = require("lodash");
class IndexController {
    constructor($scope, $location, settingsService, userService, loginService) {
        this.$scope = $scope;
        this.$location = $location;
        this.settingsService = settingsService;
        this.userService = userService;
        this.loginService = loginService;
        this.settingsService.getSettings().then(settings => {
            $scope.settings = settings;
        });
        $scope.getCurrentUser = _.bind(userService.getCurrentUser, userService);
        $scope.isUserLoggedIn = _.bind(userService.isUserLoggedIn, userService);
        $scope.logout = function () {
            loginService.logout()
                .then(function (status) {
                $location.path("/login").search('error', null);
            }, function (error) {
                $location.path("/login").search('error', "Er is een onbekende fout opgetreden bij het uitloggen");
            });
        };
    }
}
exports.IndexController = IndexController;
IndexController.$inject = ['$scope', '$location', 'settingsService', 'userService', 'loginService'];
